var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header-content-services',{attrs:{"topSpace":'padding: 60px 0px;'}}),_c('revolution'),_c('services-content-fourth'),_c('services-content-fifth'),_c('services-content-sixth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }